import { render, staticRenderFns } from "./StaticInfoAdd.vue?vue&type=template&id=acb954b0&scoped=true"
import script from "./StaticInfoAdd.vue?vue&type=script&lang=js"
export * from "./StaticInfoAdd.vue?vue&type=script&lang=js"
import style0 from "./StaticInfoAdd.vue?vue&type=style&index=0&id=acb954b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb954b0",
  null
  
)

export default component.exports